export enum AutomationTriggerType {
  CandidateMoved = 'candidate_moved',
  CandidateDisqualified = 'candidate_disqualified',
}

export type AutomationTrigger = CandidateMovedTrigger | CandidateDisqualifiedTrigger;

export type CandidateMovedTrigger = {
  type: AutomationTriggerType.CandidateMoved;
  data: CandidateMovedTriggerData;
};

export type CandidateMovedTriggerData = {
  stageId: number;
};

export type CandidateDisqualifiedTrigger = {
  type: AutomationTriggerType.CandidateDisqualified;
  data: CandidateDisqualifiedTriggerData;
};

export type CandidateDisqualifiedTriggerData = {
  disqualifyReasonId: number;
};
